<template>
  <div class="Melamine">
    <div class="title">Perchloroethylene</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <el-table-column prop="Items" label="Items"> </el-table-column>
        <!-- <el-table-column prop="Unit" label="Unit"> </el-table-column> -->
        <el-table-column prop="Specifications" label="Specifications">
        </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>In 300kg drums, 24mt/20'FCL</p>
    </div>
    <div class="item-huanhang">
      <label>Uses:</label>
      <p>Mainly used for cleaning and dry cleaning</p>
    </div>
  </div>
</template>

<script>

export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          Items: "Appearance",
          Units: "",
          Specifications:
            "Transparent liquid, without Suspended and emulsification material",
        },
        { Items: "Purity", Units: "", Specifications: "99.90min" },
        { Items: "Color, Pt-Co", Units: "", Specifications: "15max" },
        { Items: "Density(20°C)", Units: "", Specifications: "1.620-1.624" },
        { Items: "Water Content", Units: "", Specifications: "50max" },
        { Items: "Non Volatile Matter", Units: "", Specifications: "10max" },
        { Items: "Alkalinity as NaOH", Units: "", Specifications: "30max" },
        { Items: "PH", Units: "", Specifications: "8-10" },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
